"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 -0.5 14.5 14.5';

var WarningCircle = function WarningCircle() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M7,8.59121555 C7.40965468,8.59121555 7.74270727,8.25816296 7.74270727,7.84850828 L7.74270727,3.35829327 C7.74270727,2.94730638 7.40965468,2.61491989 7,2.61491989 C6.58967921,2.61491989 6.25729273,2.94730638 6.25729273,3.35829327 L6.25729273,7.84850828 C6.25729273,8.25816296 6.58967921,8.59121555 7,8.59121555 Z M7,11.3850801 C7.49075814,11.3850801 7.88859622,10.987242 7.88859622,10.4964839 C7.88859622,10.0057257 7.49075814,9.60788767 7,9.60788767 C6.50924186,9.60788767 6.11140378,10.0057257 6.11140378,10.4964839 C6.11140378,10.987242 6.50924186,11.3850801 7,11.3850801 Z"
  }));
};

var _default = (0, _createSvgIcon["default"])(WarningCircle, {
  viewBox: viewBox
});

exports["default"] = _default;